import { Entity } from './entity';
import { environment } from '../../environments/environment';
import { Loggable } from './loggable';
import { TechnicalFeature } from '@lemberger/lemberger-am';

export class PageFavorite extends Entity implements Loggable {

    pageId: number;
    assignmentSlug: string;
    index: number;
    zIndex = 3;
    logType = TechnicalFeature.Favorites;
    tool: null;

    getEndpointName(): string {
        return environment.endpointUrls.pageFavorites;
    }

}
